import { Typography } from 'shared/components/Typography';

export const GoalBreakdownTitle = () => {
  return (
    <Typography as="h3" color="black" type="heading" fontWeight="semibold">
      Goal breakdown
    </Typography>
  );
};
